/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Home {
  constructor () {
    this.home_id = uuidV4()
    this.titulo = ''
    this.secoes_html = []
  }
}
